import { useEffect, useState } from "react";
import "./FormResponsesActions.css";
import { iconPath } from "effno-core";
import { useSelector } from "react-redux";
import { selectUser } from "../../redux/features/appData";
import { ICONS } from "../shared/media";
import { Download, Settings } from "lucide-react";

type FormResponsesActionsProps = {
    onDownload: () => void;
    onOpenTableSettings: () => void;
}

export const FormResponsesActions = ({onDownload, onOpenTableSettings} : FormResponsesActionsProps) => {

    const storeUser = useSelector(selectUser);

    return (
        <div className="form-responses-actions">
            <div 
                className="form-responses-action"
                onClick={onDownload}
                style={{backgroundColor: "black", color: "white", borderColor: "black"}}
            >
                <Download size={16} />
                <div className="form-responses-action-label">
                    Download
                </div>
                {/* <img src={iconPath(ICONS.DOWNLOAD, storeUser)} alt="Download" /> */}
            </div>

            <div 
                className="form-responses-action"
                onClick={onOpenTableSettings}
            >
                <Settings size={16} />
                {/* <img src={iconPath(ICONS.SETTINGS, storeUser)} alt="Table Settings" /> */}
            </div>
        </div>
    )
}